module.exports = __webpack_public_path__ + "img/titlezh.abb3656b.png";